import { render } from "./ManagerBoardOkrugs.vue?vue&type=template&id=9c98f1a0&scoped=true"
import script from "./ManagerBoardOkrugs.vue?vue&type=script&lang=js"
export * from "./ManagerBoardOkrugs.vue?vue&type=script&lang=js"

import "./ManagerBoardOkrugs.vue?vue&type=style&index=0&id=9c98f1a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c98f1a0"]])

export default __exports__